import nodeLeft from './nodeLeft.vue'
export default nodeLeft



// WEBPACK FOOTER //
// ./src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeLeft/index.js